import { render } from "./bulk-buyers-panel.vue?vue&type=template&id=7e8d035a"
import script from "./bulk-buyers-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./bulk-buyers-panel.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./bulk-buyers-panel.vue?vue&type=style&index=0&id=7e8d035a&module=true&lang=css"
cssModules["$style"] = style0
if (module.hot) {
  module.hot.accept("./bulk-buyers-panel.vue?vue&type=style&index=0&id=7e8d035a&module=true&lang=css", () => {
    cssModules["$style"] = style0
    __VUE_HMR_RUNTIME__.rerender("7e8d035a")
  })
}

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__file',"resources/js/vueComponents/admin/analytics/components/bulk-buyers-panel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e8d035a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e8d035a', __exports__)) {
    api.reload('7e8d035a', __exports__)
  }
  
  module.hot.accept("./bulk-buyers-panel.vue?vue&type=template&id=7e8d035a", () => {
    api.rerender('7e8d035a', render)
  })

}


export default __exports__